<template>
	<b-row class="mb-3">
		<b-col cols="8">
			<b-card title="Priorities">
				<b-table
					striped
					hover
					:items="priorities"
					class="mt-3"
				></b-table>
			</b-card>
		</b-col>
		<b-col cols="4">
			<b-card title="Add Priority">
				<b-form @submit="submit" v-on:submit.prevent>
					<div
						class="form-group"
						:class="{
							'form-group--error': $v.name.$error
						}"
					>
						<label class="form__label">Name</label>
						<input
							type="text"
							class="form-control form__input"
							v-model.trim="$v.name.$model"
						/>
					</div>

					<div
						class="error mb-2 text-danger"
						v-if="!$v.name.required"
					>
						Field is required
					</div>
					<div
						class="error mb-2 text-danger"
						v-if="!$v.name.minLength"
					>
						Name must have at least
						{{ $v.name.$params.minLength.min }}
						letters.
					</div>

					<div
						class="form-group"
						:class="{
							'form-group--error': $v.duration.$error
						}"
					>
						<label class="form__label">Duration (hours)</label>
						<input
							type="text"
							class="form-control form__input"
							v-model.trim="$v.duration.$model"
						/>
					</div>

					<div
						class="error mb-2 text-danger"
						v-if="!$v.duration.required"
					>
						Field is required
					</div>
					<div
						class="error mb-2 text-danger"
						v-if="!$v.duration.minValue"
					>
						Duration must be at least
						{{ $v.duration.$params.minValue.min }}
						hour.
					</div>

					<div class="form-group">
						<button
							type="submitGroup"
							class="btn btn-primary btn-block rounded-0 text-uppercase"
						>
							Submit
						</button>
					</div>

					<div class="form-group">
						<p
							class="typo__p text-success"
							v-if="submitStatus === 'OK'"
						>
							Form submitted successfully.
						</p>
						<p
							class="typo__p text-danger"
							v-if="submitStatus === 'ERROR'"
						>
							Please fill the form correctly.
						</p>
						<p
							class="typo__p text-info"
							v-if="submitStatus === 'PENDING'"
						>
							Submitting . . .
						</p>
					</div>
				</b-form>
			</b-card>
		</b-col>
	</b-row>
</template>

<script>
import { api } from "../../../config";
import {
	required,
	minLength,
	minValue,
	numeric
} from "vuelidate/lib/validators";
export default {
	data: () => ({
		name: "",
		duration: null,
		submitStatus: null,
		priorities: []
	}),
	async mounted() {
		await this.getTicketPriorities();
	},
	methods: {
		async getTicketPriorities() {
			let request = await fetch(`${api}/tickets/priorities`, {
				headers: {
					"Content-Type": "application/json",
					Authorization: `Bearer ${this.$store.getters.token}`
				}
			});
			let response = await request.json();
			this.priorities = [];
			response.forEach(priority => {
				this.priorities.push({
					name: priority.name,
					duration: `${
						priority.duration
					} ${this.$options.filters.unitNamePlurality(
						priority.duration,
						"hour"
					)}`
				});
			});
			this.priorities.sort(
				(a, b) => parseFloat(a.duration) - parseFloat(b.duration)
			);
		},
		async submit() {
			this.$v.$touch();
			if (this.$v.$invalid) {
				this.submitStatus = "ERROR";
			} else {
				this.submitStatus = "PENDING";
				await fetch(`${api}/tickets/priorities`, {
					method: "POST",
					body: JSON.stringify({
						name: this.name,
						duration: this.duration
					}),
					headers: {
						"Content-Type": "application/json",
						Authorization: `Bearer ${this.$store.getters.token}`
					}
				});
				await this.getTicketPriorities();
				this.name = null;
				this.duration = null;
				this.submitStatus = "OK";
			}
		}
	},
	validations: {
		name: {
			required,
			minLength: minLength(3)
		},
		duration: {
			required,
			numeric,
			minValue: minValue(1)
		}
	}
};
</script>
